// Constants for API configuration
const API_URL = process.env.REACT_APP_GOLD_API_URL;

// Function to fetch gold price for a specific currency
export const fetchGoldPrice = async (currency) => {
  try {
    const response = await fetch(`${API_URL}/${currency}`);

    if (!response.ok) {
      throw new Error('Failed to fetch gold prices');
    }

    const data = await response.json();
    return {
      price: data.price,
      currency: data.currency,
      timestamp: data.timestamp
    };
  } catch (error) {
    console.error('Error fetching gold price:', error);
    throw error;
  }
}; 